module.exports = __webpack_public_path__ + "img/web_icon_wifi.92fc8200.png";